<template>
  <div class="content">
    <div v-if=" addMemberShow == 0">
      <div class="button-group-title">
        <el-button type="primary" @click="addMemberShow = 1" :plain="true">
          <i class="el-icon-circle-plus"></i>
          邀请新成员
        </el-button>
      </div>
      <!--搜索框-->
      <div style="margin: 10px 15px 10px 15px;">
        <el-input placeholder="请输入搜索用户的名称" v-model="searchNickName" clearable @clear="clearState">
          <el-select style="width: 160px" v-model="select" slot="prepend" placeholder="请选择审核状态"
                     @change="getStateMemberList">
            <el-option label="全部" value="3"></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核失败" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="getStateMemberList"></el-button>
        </el-input>
      </div>
      <div style="margin: 10px 15px 10px 15px;">
        <el-table :data="stateUserList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="userId" label="人员id" width="80" show-overflow-tooltip align="center"/>
          <el-table-column prop="nickname" label="人员姓名" width="120" show-overflow-tooltip align="center"/>
          <el-table-column label="人员身份" width="120" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <div class="info-content" v-if="scope.row.role_type == 0">开发者</div>
              <div class="info-content" v-if="scope.row.role_type == 1">用户</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="268.5" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <el-button style="height:50px;width: 100px" type="primary" :plain="true" @click="handleEditIdBtnClick(scope.row)">
                <i class="el-icon-edit"></i>
                <div style="font-size: 15px; font-weight: 400; font-style: normal;">修改</div>
              </el-button>

              <el-button style="height:50px;width: 100px" type="warning" :plain="true"
                         @click="showDialog(scope.row)">
                <i class="el-icon-delete"></i>
                <div style="font-size: 15px; font-weight: 400; font-style: normal;">删除</div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="170" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <div class="info-content" v-if="scope.row.isAccept == 0">待审核</div>
              <div class="info-content" v-if="scope.row.isAccept == 1">审核通过</div>
              <div class="info-content" v-if="scope.row.isAccept == 2">审核失败</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 确认删除人员的对话框-->
      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
        <span>确认删除？</span>
        <span slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="delMember">确 定</el-button>
          </span>
      </el-dialog>

      <!-- 修改成员身份的模态窗 -->
      <el-dialog title="修改成员身份" :visible.sync="roleShow">
        <el-form>
          <el-form-item label="用户身份">
            <el-radio-group v-model="value">
              <el-radio label="开发者">开发者</el-radio>
              <el-radio label="用户">用户</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleShow = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirmBtnClick">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!--    <el-button type="primary" style="margin: 10px 15px 10px 15px;" @click="returnBack">返回管理的公司</el-button>-->
    <AddMember v-if="addMemberShow == 1" :companyId="companyId" @returnBack="returnBack"></AddMember>
  </div>
</template>

<script>
import API from "../../../../config/api";
import IMGURL from "../../../../config/imgUrl"
import AddMember from "@/pages/userCenter/ChildComps/addMember";

export default {
  data() {
    return {
      appendChild: {},
      developerList: [],
      projectId: '',
      userId: '', //登录用户
      logoMember: IMGURL.logoMember,
      logoDelMember: IMGURL.logoDelMember,
      logoAgree: IMGURL.logoAgree,
      logoDisagree: IMGURL.logoDisagree,
      stateUserList: [], //被邀请用户的审核状态的列表

      activeName: 'first', //默认选中的tab
      searchName: '',      //在公司成员页面搜索成员的时候输入的用户名
      searchNickName: '',  //在查看用户对公司邀请审核状态页面输入的用户名
      dialogVisible: false, //删除成员的对话框是否显示
      deleteUserId: '',//要删除的用户的id
      roleShow: false,   //修改用户身份的模态窗
      value: '',
      tempId: null,
      select: '3', //被邀请用户的审核状态的筛选
      addMemberShow: 0,  //切换邀请新成员界面

    }
  },
  components: {
    AddMember
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
    console.log('人员管理userId的值=', this.userId);
    console.log(this.companyId)
    console.log('开始进行公司员工处理ing')
    this.developerList = []
    this.getAllDeveloperOfCompany(); //在页面上显示该公司的所有开发者
    this.stateUserList = [];
    this.getUserAll(); //初始化被邀请用户的审核状态
  },
  methods: {
    //页面切换
    handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
    },
    //展示删除人员的对话框
    showDialog(item) {
      this.deleteUserId = item.userId;
      this.dialogVisible = true;
    },
    // 删除人员
    delMember() {
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        updateUserId: this.deleteUserId
      }

      this.$axiosRequest({
        url: API.removeUserFromCompany,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          // -1：删除失败
          if (res.data == -1) {
            self.$message({type: 'warning', message: '删除失败'});
            self.dialogVisible = false;
          } else if (res.data == -2) {
            self.$message({type: 'warning', message: '参数错误'});
            self.dialogVisible = false;
          } else if (res.data == 0) {
            self.$message({type: 'warning', message: '关系不存在'});
            self.dialogVisible = false;
          }
          // 1：删除成功，需要把对应的人员从列表中去除
          else if (res.data == 1) {
            self.$message({type: 'success', message: '删除成功'});
            self.dialogVisible = false;
            self.getStateMemberList(); //重新刷新
          }
        }
      });
    },
    //修改用户的身份，模态框提示
    handleEditIdBtnClick(item) {
      if (item.role_type == 0)
        this.value = '开发者'
      if (item.role_type == 1)
        this.value = '用户'
      console.log(item)
      this.roleShow = true
      this.tempId = item.userId
    },
    // 获取当前公司所有的员工，其中新加了人员身份
    getAllDeveloperOfCompany() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      // 参数要有当前公司的companyId
      let data = {
        companyId: this.companyId,
        nickname: this.searchName

      }
      console.log(data)
      // 获取非当前用户的其他所有用户
      this.$axiosRequest({
        url: API.getAllDeveloperOfCompany,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.developerList = []
          let list = res.data["userList"];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isAccept == true)         //找出已经成功加入公司的成员
            {
              this.developerList.push(list[i]);
            }
          }
          console.log(this.developerList)

        }
      });
    },
    //清空成员列表搜索框
    clear() {
      this.developerList.length = 0;   //重新刷新一下    //先把列表清空
      this.getAllDeveloperOfCompany();
    },
    //清空不同审核状态的成员搜索框
    clearState() {
      this.stateUserList = [];   //重新刷新一下    //先把列表清空
      this.getStateMemberList();
    },
    //返回管理的公司列表
    returnBack() {
      this.addMemberShow = 0;
      this.getStateMemberList();
    },
    //初始化被邀请用户的审核状态
    getUserAll() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      // 参数要有当前公司的companyId
      let data = {
        companyId: this.companyId,
      }
      console.log(data)
      // 获取非当前用户的其他所有用户
      this.$axiosRequest({
        url: API.getAllDeveloperOfCompany,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.stateUserList = res.data["userList"];
        }
      });
    },
    //作为公司管理者邀请用户，用户的审核通过状态
    getStateMemberList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        nickname: this.searchNickName
      }
      console.log('列表data=', data)
      this.$axiosRequest({
        url: API.getAllDeveloperOfCompany,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let list = res.data["userList"];
          this.stateUserList = [];
          if (this.select == 0) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 0)         //找出还没审核加入公司的成员
              {
                this.stateUserList.push(list[i]);
              }
            }
          }
          if (this.select == 1) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 1)         //找出已经成功加入公司的成员
              {
                this.stateUserList.push(list[i]);
              }
            }
          }
          if (this.select == 2) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 2)         //找出拒绝加入公司的成员
              {
                this.stateUserList.push(list[i]);
              }
            }
          }
          if (this.select == 3) {
            this.stateUserList = list;
          }
        }
      })
    },
    //接口修改成员身份
    handleConfirmBtnClick() {
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let role;
      if (this.value == '开发者') {
        role = 0;
      }
      if (this.value == '用户') {
        role = 1;
      }
      // 参数要有当前公司的companyId
      let data = {
        companyId: this.companyId,
        updateUserId: this.tempId,
        role_type: role

      }
      console.log(data)
      // 获取非当前用户的其他所有用户
      this.$axiosRequest({
        url: API.updateCompanyUser,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data == 1) {
            self.$message({type: 'success', message: '修改成功'});
            self.roleShow = false;
            self.getStateMemberList();
          } else if (res.data == 0) {
            self.$message({type: 'warning', message: '公司和该用户没有关联'});
            self.roleShow = false;
          } else if (res.data == -2) {
            self.$message({type: 'warning', message: '该用户不存在'});
            self.roleShow = false;
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '程序错误'});
            self.roleShow = false;
          }
        }
      });
    },

  },
}
</script>

<style lang="less">
.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  // font-weight: bold;
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  // background-color: rgba(240, 240, 240, 0.5);
  padding: 24px;
}

.button-group-title {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  font-size: 18px;
  font-weight: bold;
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  line-height: 40px;
}

.btn {
  margin-left: 80px;

}
</style>
